import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAccessControl } from '../../hooks/useAccessControl';
import { isSourcingOnly } from '../../utils/sidebarPreferences';
import AppLoading from '../AppLoading';

export default function WorkspaceLanding({ children }) {
  const { productTypes, loading } = useAccessControl();
  const location = useLocation();
  if (loading) return <AppLoading />;
  // Keep explicit Home and job-posting links reachable from the same menu.
  if (!location.state?.showHome && !location.state?.openPostJob && isSourcingOnly(productTypes)) {
    return <Navigate to="/sourcing?view=search" replace />;
  }
  return children;
}
